// apps/share-web/src/chart/chart-font.ts
//
// Размер листа — ПРОЦЕНТЫ к базе поверхности (words page v2, спека 2026-09-14).
//
// ⚠️ Наружу едут проценты, а не пиксели, и это не стилистика. У панели база
// 15px, у полного экрана 19px (chart.css), и разница осознанная: панель смотрят
// с вытянутой руки, слой — со стойки. Процент применяется к базе СВОЕЙ
// поверхности, и обе остаются в своих пропорциях. Пиксели здесь не считаются
// вовсе: множитель уезжает в CSS (`--cw-fs-scale`), база остаётся там, где
// стояла (`--cw-fs-base`).
//
// Было: геометрическая шкала 1.1^шаг из шести пунктов в дропдауне (−2…+4).
// Сергей 14.09: «текст сайз не был ограничен туда-сюда, а больше можно было
// сколько угодно накручивать» — отсюда степпер по 5 % и технический потолок
// +300 вместо шкалы. Нижняя граница −50: дальше строки чарта не читаются.

export const FONT_PCT_STEP = 5;
export const FONT_PCT_MIN = -50;
export const FONT_PCT_MAX = 300;

/** Процент в пределах диапазона, кратный шагу. Мусор — ноль, то есть база. */
export const clampFontPct = (v: unknown): number => {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;
  const snapped = Math.round(n / FONT_PCT_STEP) * FONT_PCT_STEP;
  return Math.max(FONT_PCT_MIN, Math.min(FONT_PCT_MAX, snapped));
};

/** Множитель к базе поверхности. Прижимает сам — наружу не уедет вне диапазона. */
export const fontScale = (pct: unknown): number => 1 + clampFontPct(pct) / 100;

/** Подпись степпера: «0», «+20%», «−5%» — настоящий минус U+2212, не дефис. */
export const fontPctLabel = (pct: unknown): string => {
  const p = clampFontPct(pct);
  if (p === 0) return '0';
  return p > 0 ? `+${p}%` : `−${-p}%`;
};

/**
 * Старый шаг шкалы (1.1^n, ключ `bw.chart.fs` у плеера) → проценты. Нужен ровно
 * один раз — при миграции сохранённого значения (reader-prefs.ts).
 */
export const legacyStepToPct = (step: unknown): number => {
  const n = Number(step);
  if (!Number.isFinite(n)) return 0;
  return clampFontPct(Math.round((1.1 ** Math.round(n) - 1) * 100));
};
